import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Terminal } from 'lucide-react';
import { HabbitLogo } from '../HabbitLogo';
export function MarketingNav() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/90 backdrop-blur-md border-b border-surface-200/50" data-id="element-202">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-203">
        <Link to="/" className="flex items-center gap-3" data-id="element-204">
          <HabbitLogo size={34} data-id="element-205" />
          <span className="text-2xl font-mono font-bold tracking-tight text-gray-100" data-id="element-206">
            habbit<span className="text-centurion-500" data-id="element-207">.</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-208">
          <div className="flex items-center gap-6" data-id="element-209">
            <a href="#protocol" className="text-sm font-mono font-medium text-gray-400 hover:text-centurion-400 transition-colors uppercase tracking-wider" data-id="element-210">
              The Protocol
            </a>
            <a href="#peer-board" className="text-sm font-mono font-medium text-gray-400 hover:text-centurion-400 transition-colors uppercase tracking-wider" data-id="element-211">
              Peer Board
            </a>
            <a href="#privacy" className="text-sm font-mono font-medium text-gray-400 hover:text-centurion-400 transition-colors uppercase tracking-wider" data-id="element-212">
              Privacy
            </a>
          </div>
          <Link to="/app" className="bg-surface-300 border border-surface-200 hover:border-centurion-500/50 text-gray-200 hover:text-centurion-400 px-5 py-2.5 rounded text-sm font-mono font-bold tracking-wide transition-all flex items-center gap-2 shadow-[0_0_15px_rgba(0,0,0,0.5)]" data-id="element-213">
            <Terminal size={16} data-id="element-214" />
            Initialize System
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setIsOpen(!isOpen)} data-id="element-215">
          {isOpen ? <X size={24} data-id="element-216" /> : <Menu size={24} data-id="element-217" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden absolute top-20 left-0 right-0 bg-surface-500 border-b border-surface-200 p-6 flex flex-col gap-4 shadow-2xl" data-id="element-218">
          <a href="#protocol" onClick={() => setIsOpen(false)} className="text-lg font-mono font-medium text-gray-300 hover:text-centurion-400 py-2 uppercase tracking-wider" data-id="element-219">
            The Protocol
          </a>
          <a href="#peer-board" onClick={() => setIsOpen(false)} className="text-lg font-mono font-medium text-gray-300 hover:text-centurion-400 py-2 uppercase tracking-wider" data-id="element-220">
            Peer Board
          </a>
          <a href="#privacy" onClick={() => setIsOpen(false)} className="text-lg font-mono font-medium text-gray-300 hover:text-centurion-400 py-2 uppercase tracking-wider" data-id="element-221">
            Privacy
          </a>
          <Link to="/app" onClick={() => setIsOpen(false)} className="bg-surface-300 border border-surface-200 text-gray-200 px-5 py-3 rounded text-center font-mono font-bold mt-2 flex items-center justify-center gap-2 uppercase tracking-wider" data-id="element-222">
            <Terminal size={18} data-id="element-223" />
            Initialize System
          </Link>
        </div>}
    </nav>;
}